function loadUserDashboard(view) {
    return () => import( /* webpackChunkName: "dashboard-user-[request]" */ `@/components/dashboard/user/${view}.vue`)
}

const routes = [
    {
        path: 'user-account/crew',
        name: 'CrewUser',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['superadmin','bkak']
        },
        component: loadUserDashboard('Crew'),
    },
    {
        path: 'user-account/jobseeker',
        name: 'JobSeekerUser',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['superadmin','bkak', 'crew']
        },
        component: loadUserDashboard('JobSeeker'),
    },
    {
        path: 'user-account/jobseeker/:id',
        name: 'JobSeekerUserDetail',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['superadmin','bkak','prhn','kprhn','crew']
        },
        component: loadUserDashboard('JobSeekerDetail'),
    },
    {
        path: 'user-account/company',
        name: 'CompanyUser',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['superadmin','bkak','crew']
        },
        component: loadUserDashboard('Company'),
    },
    {
        path: 'user-account/staff',
        name: 'CompanyStaff',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['prhn']
        },
        component: loadUserDashboard('Staff'),
    },
]

export default routes